<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-if="role === 'admin'" v-slot:navbarname>
        <b-link
            :to="{name:'AddProduct',params:{'categoryid':$route.params.categoryid}}"
            class="btn btn-primary btn-round">
          + Neue Produkt
        </b-link>
      </template>
    </navbar>
    <!--END Navbar-->

    <h2>
      <span class="font-weight-bold">{{ categoryTitle }}</span>
    </h2>

    <b-form-checkbox v-if="role === 'admin'" v-model="selectAllProducts">Select All</b-form-checkbox>

    <b-card class="sticky-top" title="Filter">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-radio-group
              id="radio-group-1"
              v-model="filter.type"
              :options="filter.items"
              name="radio-options"
              @change="getProducts"
          ></b-form-radio-group>

          <b-link v-if="filter.type !== null"
                  @click="deleteFilter"
                  class="text-danger">remove filter
          </b-link>
        </b-col>

        <b-col cols="12" md="6">
          <b-row>
            <b-col cols="12" md="6">
              <b-input v-model="searchInput" placeholder="search"></b-input>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group>
                <b-form-select
                    @input="onChangeSubCategory"
                    :options="categoryItem.subCategories"
                    class="mb-3"
                    value-field="id"
                    text-field="title"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </b-card>

    <template v-if="role === 'admin'">


      <b-card :title="this.$t('selectAction')" v-if="filter.processGroup.productIds.length > 0">
        <b-form-select
            @change="processGroupFunc"
            v-model="filter.processGroup.type">
          <b-form-select-option value="comingsoon">active Bald im Sortiment</b-form-select-option>
          <b-form-select-option value="publish">disable Bald im Sortiment</b-form-select-option>
          <b-form-select-option value="hide">Hide</b-form-select-option>
          <b-form-select-option value="show">Show</b-form-select-option>
          <b-form-select-option value="inavailbale">unavailable</b-form-select-option>
          <b-form-select-option value="availbale">available</b-form-select-option>
        </b-form-select>
      </b-card>

    </template>

    <template v-if="items.length > 0">

      <draggable v-model="items" group="items"
                 @update="updateOrder"
                 handle=".handle"
                 @start="drag=true"
                 @end="drag=false">
        <b-card
            v-for="(item,index) in getProductsSearch"
            :key="index"
            :class="{'border border-danger':item.is_offer,'bg-dark':item.is_hidden === 'yes'}">


          <b-row>
            <b-col cols="12" md="8">
              <b-media left-align vertical-align="center">
                <template #aside>
                  <b-img :src="item.image"
                         style="object-fit: contain"
                         height="45"
                         width="80" alt="placeholder"></b-img>
                </template>
                <h5 class="mt-0 mb-1 font-weight-bold" v-html="item.title"></h5>
                <p class="mt-0 mb-1">{{ item.priceTitle }}</p>

                <p class="mb-0">
                  <b-link
                      :to="{name:'EditProduct',params:{'productid':item.id}}"
                      class="mr-4">
                    <span class="material-icons font-14">create</span>
                    <span>edit</span>
                  </b-link>
                  <b-link
                      v-if="role === 'admin'"
                      @click.prevent="copyProduct(item.id)"
                      class="mr-4">
                    <span class="material-icons font-14">content_copy</span>
                    <span>copy</span>
                  </b-link>
                  <b-link
                      v-if="role === 'admin'"
                      @click="deleteProduct(item.id)"
                      class="text-danger">delete
                  </b-link>

                </p>
              </b-media>
            </b-col>
            <b-col cols="12" md="4">
              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Preis
                  <span class="font-weight-bold">
                                        <template v-if="item.is_offer">
                                            <span class="mr-2"
                                                  style="text-decoration: line-through">{{ item.price }}</span>
                                            <span class="text-danger">{{ item.price_sell }}</span>
                                        </template>
                                        <template v-else>
                                            <span>{{ item.price }}</span>
                                        </template>
                                    </span>
                </b-list-group-item>

                <b-list-group-item
                    v-if="item.is_offer"
                    class="d-flex justify-content-between align-items-center">
                  offer percent
                  <span>{{ item.offer_percent }} %</span>
                </b-list-group-item>

                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Inventar
                  <span>{{ item.count }}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Brand
                  <span>{{ item.brand }}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Sub Category
                  <span>{{ item.subCategory }}</span>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>


          <b-card-footer v-if="role === 'admin'">
            <b-form-checkbox
                :id="'checkbox-'+item.id"
                :name="'checkbox-'+item.id"
                v-model="filter.processGroup.productIds"
                :value="item.id"
            >
              select
            </b-form-checkbox>
          </b-card-footer>


          <div class="text-right">
                            <span class="mr-3 handle">
                                <span class="material-icons">drag_handle</span>
                            </span>
          </div>

        </b-card>
      </draggable>

    </template>


  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notification from '../../Services/Notification/Nottification'
import draggable from 'vuedraggable'

export default {
  name: "Index",
  components: {
    Navbar,
    draggable
  },
  data() {
    return {
      role: null,
      categoryTitle: null,
      searchInput: null,
      items: [],
      categoryItem: {
        subCategories: []
      },
      filter: {
        subCategory: null,
        processGroup: {
          productIds: [],
          type: null
        },
        items: [
          {
            text: 'Angebot',
            value: 'offer'
          },
          {
            text: 'Beseller',
            value: 'beseller'
          },
          {
            text: 'versteckt',
            value: 'hidden'
          },

        ],
        type: null
      }
    }
  },
  computed: {
    getProductsSearch() {
      if (this.searchInput === null) {
        return this.items;
      }

      return this.items.filter(item => {
        return item.title.toLowerCase().match(this.searchInput.toLowerCase())
      })
    },
    selectAllProducts: {
      get: function () {
        return this.items ? this.filter.processGroup.productIds.length == this.items.length : false;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.items.forEach(function (comment) {
            selected.push(comment.id);
          });
        }

        this.filter.processGroup.productIds = selected;
      }
    }
  },
  methods: {
    deleteFilter() {
      this.filter.type = null;
      this.getProducts();
    },
    onChangeSubCategory(event) {
      this.filter.type = "subCategory";
      this.getProducts(event);
    },
    getProducts(subCategory = null) {
      if (this.$route.params.categoryid && this.$route.params.categoryid > 0) {
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'product/index', {
          categoryId: this.$route.params.categoryid,
          filterType: this.filter.type,
          subCategory: subCategory
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.categoryTitle = response.data.data.category;
                this.items = response.data.data.items;
                this.categoryItem.subCategories = response.data.data.subCategories;
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    updateOrder() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'product/order/update', {
        items: this.items
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              //this.getProducts();
              Notification.success(response.data.message)
            } else {
              Notification.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    deleteProduct(myId) {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.get(Http.apiurlV2() + 'product/delete/' + myId)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.getProducts();
                Notification.success(response.data.message)
              } else {
                Notification.error(response.data.message)

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    copyProduct(myId) {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.get(Http.apiurlV2() + 'product/copy/' + myId)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.getProducts();
                Notification.success(response.data.message)
              } else {
                Notification.error(response.data.message)

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    processGroupFunc() {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'product/process/group', {
          productIds: this.filter.processGroup.productIds,
          type: this.filter.processGroup.type,
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.getProducts();
                Notification.success(response.data.message)
              } else {
                Notification.error(response.data.message)

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
  },
  created() {
    this.getProducts();
  },
  mounted() {
    this.role = localStorage.getItem('role');
  }
}
</script>

<style scoped>

</style>